import { http } from '../api/https/http'

export function downloadZipFile(url, filename) {
  return new Promise((resolve, reject) => {
    http({
      url,
      method: 'GET',
      responseType: 'arraybuffer',
    })
      .then(response => {
        const blobUrl = window.URL.createObjectURL(
          new Blob([response.data], { type: 'application/zip' }),
        )
        const tempLink = document.createElement('a')
        tempLink.href = blobUrl
        tempLink.setAttribute('download', filename)
        tempLink.click()
        resolve()
      })
      .catch(e => {
        const responseData = e && e.response && e.response.data
        if (!responseData) {
          reject(
            (e && e.message) || 'Não foi possível baixar o arquivo. Serviço de documentos indisponível.',
          )
          return
        }

        const blob = new Blob([responseData], { type: 'text/plain' })
        const reader = new FileReader()

        // This fires after the blob has been read/loaded.
        reader.addEventListener('loadend', event =>
          reject(event.target.result || `Erro ${e.response.status} ao baixar o arquivo.`),
        )

        // Start reading the blob as text.
        reader.readAsText(blob)
      })
  })
}

export function downloadFile(blob, fileName) {
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = fileName
  a.click()
}

export function openDownloadedFile(blob) {
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.target = '_blank'
  a.rel = 'noopener noreferrer'
  // a.download = fileName
  a.click()
}

export function parseBlobToString(blob) {
  const blb = new Blob([blob], { type: 'text/plain' })
  return blb.text()
}
